/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Country_AutomaticInputs */

const en_pricing_country_automatic = /** @type {(inputs: Pricing_Country_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic (your location)`)
};

const es_pricing_country_automatic = /** @type {(inputs: Pricing_Country_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático (tu ubicación)`)
};

/**
* | output |
* | --- |
* | "Automatic (your location)" |
*
* @param {Pricing_Country_AutomaticInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_country_automatic = /** @type {((inputs?: Pricing_Country_AutomaticInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Country_AutomaticInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_country_automatic(inputs)
	return en_pricing_country_automatic(inputs)
});